import { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { api, apiError } from "@/lib/api";
import { Mail, Phone, MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const { settings } = useSettings();
  const c = settings.contact || {};
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", { ...f, hp: "" });
      toast.success("Message sent! We'll be in touch.");
      setF({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full rounded border border-kys-blush-border bg-white px-3 py-2.5 text-sm focus:border-kys-accent focus:outline-none";

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <p className="label-accent text-kys-accent">Get in Touch</p>
          <h1 className="mt-3 font-serif text-4xl tracking-tight text-kys-ink sm:text-5xl">Contact Us</h1>
          <p className="mt-4 text-sm text-kys-charcoal">{c.note || "Questions about a piece or a custom order? Send a message."}</p>
          <div className="mt-8 space-y-4 text-sm text-kys-charcoal">
            <p className="flex items-center gap-3"><Mail className="h-4 w-4 text-kys-accent" /> {c.email || "[Email to be added]"}</p>
            <p className="flex items-center gap-3"><Phone className="h-4 w-4 text-kys-accent" /> {c.phone || "[Phone to be added]"}</p>
            <p className="flex items-center gap-3"><MapPin className="h-4 w-4 text-kys-accent" /> {c.location || "[Location to be added]"}</p>
          </div>
        </div>
        <form onSubmit={submit} className="rounded-md border border-kys-blush-border bg-white p-6">
          <div className="space-y-3">
            <input data-testid="contact-name" required placeholder="Your name" value={f.name} onChange={set("name")} className={inputCls} />
            <input data-testid="contact-email" required type="email" placeholder="Your email" value={f.email} onChange={set("email")} className={inputCls} />
            <textarea data-testid="contact-message" required rows={5} placeholder="Your message" value={f.message} onChange={set("message")} className={inputCls} />
          </div>
          <button data-testid="contact-submit" disabled={busy} className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-kys-ink py-3.5 text-sm font-semibold text-white transition hover:bg-kys-accent disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
